import { defineComponent, PropType } from "vue";
import { Link } from "@/interfaces/Link";
import { Image } from "@/interfaces/Image";

interface AgendaItem {
  link: Link;
  title: string;
  text: string;
  date: string;
  dateTo?: string;
  image?: Image;
  partner?: string;
}

export default defineComponent({
  props: {
    agendaItems: { type: Array as PropType<AgendaItem[]>, required: true },
  },
});
